var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes.root},[(_vm.icon)?_c('div',{staticClass:"f-y-center"},[_c('icon',{staticClass:"no-shrink _mr-0.5",attrs:{"name":_vm.icon,"color":_vm.colors.icon}}),_c('span',{staticClass:"no-wrap"},[_vm._v(_vm._s(_vm.label))])],1):_c('span',{staticClass:"no-wrap"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }